import { styled } from "@vitality-ds/system";
import baseStatusBadgeStyles from "./styles/BaseStatusBadge.styles";
export var BaseStatusBadge = styled("div", baseStatusBadgeStyles);
export var BaseStatusBadgeLink = styled("a", baseStatusBadgeStyles);
export var BaseStatusBadgeButton = styled("button", baseStatusBadgeStyles);